import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Empêche un utilisateur déjà connecté d'afficher /login ou /login/admin => redirigé vers le
 * cockpit.
 *
 * Et pendant une coupure, ces pages n'ont rien à montrer non plus : sans ce garde, un visiteur
 * non connecté voyait l'écran de connexion normal, cliquait, et échouait sans explication.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.backendReachable()) {
    return router.createUrlTree(['/unavailable']);
  }
  return auth.isAuthenticated() ? router.createUrlTree(['/']) : true;
};
